module.exports = __webpack_public_path__ + "media/img/pages/companies/zhaw_life_scienses-36fb0589d8844d2247190dd7b0be14d2.png";